module.exports = __webpack_public_path__ + "static/media/word_icon.74b06143.png";